const available = {
    context: [
        'arabic',
        'german',
        'spanish',
        'french',
        'hebrew',
        'italian',
        'japanese',
        'dutch',
        'polish',
        'portuguese',
        'romanian',
        'russian',
        'turkish',
        'chinese',
        'english',
        'swedish',
    ],
    spell: ['english', 'french', 'italian', 'spanish'],
    synonyms: [
        'english',
        'russian',
        'german',
        'spanish',
        'french',
        'polish',
        'italian',
        'arabic',
        'hebrew',
        'japanese',
        'dutch',
        'portugese',
        'romanian',
    ],
    translation: [
        'arabic',
        'german',
        'spanish',
        'french',
        'hebrew',
        'italian',
        'japanese',
        'dutch',
        'polish',
        'portuguese',
        'romanian',
        'russian',
        'turkish',
        'chinese',
        'english',
        'ukrainian',
    ],
    conjugation: [
        'english',
        'russian',
        'french',
        'spanish',
        'german',
        'italian',
        'portuguese',
        'hebrew',
        'arabic',
        'japanese',
    ],
}

module.exports = available
